module.exports = __webpack_public_path__ + "static/media/cam_small.4a83b96d.svg";